// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#readmorefootercon li {
  line-height: 1.1;
  margin-bottom: 5px;
  padding: 0 10px;
  font-size: 13px;
  border-right: 2px solid #b7b7b7;
}
#readmorefootercon li a {
  color: #b7b7b7;
}
.fa-linkedin {
  background: #007bb5;
  color: #fff;
}
.fa-youtube {
  background: #b00;
  color: #fff;
}
.fa-instagram {
  background: #125688;
  color: #fff;
}
.fa-facebook {
  background: #3b5998;
  color: #fff;
}
.fa-twitter {
  background: #55acee;
  color: #fff;
}
footer .top-footer .social-links i {
  font-size: 30px;
  margin-left: 3px;
  padding: 5px;
  width: 38px;
  height: 37px;
}
.fa-facebook-f::before,
.fa-facebook::before {
  content: "\\f09a";
  margin-left: 6px;
}

@media (width <=676px) {
  #footerresponce,
  #footerresponce1 {
    display: none;
  }
}

@media (width <= 676px) {
  footer .top-footer .footer-logo {
    display: block;
    margin-left: 64px;
  }

  #our-project {
    display: none;
  }

  .bottom-footer {
    display: none;
  }

  .Whatsupbuttn {
    display: none;
  }
}
.custom-link {
  color: #737373 !important;
}

footer .top-footer {
  padding: 30px 0 0;
  background-color: #121212;
  border-top: 1px solid #686060;
}

footer .top-footer li a {
  color: #737373;
  text-decoration: none;
}

footer .bottom-footer .container {
  border-top: 1px solid #686060;
}

footer .top-footer li a:hover {
  color: #fff;
  text-decoration: none;
}

.Whatsupbuttn {
  position: fixed;
  left: 30px;
  bottom: 5px;
  height: auto;
  background: #9990;
  z-index: 1001;
  display: block; /* Ensure it is displayed by default */
}


/* Hide GIF on small screens (below 676px) */
@media (max-width: 675px) {
  .Whatsupbuttn {
    display: none;
  }
}

/* Hide CTA on tablets (768px - 1024px) */
@media (min-width: 768px) and (max-width: 1024px) {
  .CTA {
    display: none !important; /* Forcefully hide CTA */
  }
  .Whatsupbuttn {
    display: block !important; /* Ensure GIF is visible */
  }
}

.social-links img {
  border-radius: 19px;
  margin-left: 5px;
  height: 34px;
  width: 34px;
}

.social-links {
  display: flex;
  flex-wrap: wrap;
}

@media (max-width: 576px) {
  .top-footer .col {
    flex: 0 0 50%; /* 2 columns for small screens */
    max-width: 50%;
  }
}

@media (min-width: 768px) {
  .top-footer .col {
    flex: 0 0 33.33%; /* 3 columns for tablets */
    max-width: 33.33%;
  }
}

@media (min-width: 992px) {
  .top-footer .col {
    flex: 0 0 25%; /* 4 columns for desktops */
    max-width: 25%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/app/components/styles/css/footer.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,+BAA+B;AACjC;AACA;EACE,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,YAAY;AACd;AACA;;EAEE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE;;IAEE,aAAa;EACf;AACF;;AAEA;EACE;IACE,cAAc;IACd,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;AACF;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,UAAU;EACV,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,cAAc,EAAE,sCAAsC;AACxD;;;AAGA,4CAA4C;AAC5C;EACE;IACE,aAAa;EACf;AACF;;AAEA,yCAAyC;AACzC;EACE;IACE,wBAAwB,EAAE,wBAAwB;EACpD;EACA;IACE,yBAAyB,EAAE,0BAA0B;EACvD;AACF;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE;IACE,aAAa,EAAE,gCAAgC;IAC/C,cAAc;EAChB;AACF;;AAEA;EACE;IACE,gBAAgB,EAAE,0BAA0B;IAC5C,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,aAAa,EAAE,2BAA2B;IAC1C,cAAc;EAChB;AACF","sourcesContent":["#readmorefootercon li {\n  line-height: 1.1;\n  margin-bottom: 5px;\n  padding: 0 10px;\n  font-size: 13px;\n  border-right: 2px solid #b7b7b7;\n}\n#readmorefootercon li a {\n  color: #b7b7b7;\n}\n.fa-linkedin {\n  background: #007bb5;\n  color: #fff;\n}\n.fa-youtube {\n  background: #b00;\n  color: #fff;\n}\n.fa-instagram {\n  background: #125688;\n  color: #fff;\n}\n.fa-facebook {\n  background: #3b5998;\n  color: #fff;\n}\n.fa-twitter {\n  background: #55acee;\n  color: #fff;\n}\nfooter .top-footer .social-links i {\n  font-size: 30px;\n  margin-left: 3px;\n  padding: 5px;\n  width: 38px;\n  height: 37px;\n}\n.fa-facebook-f::before,\n.fa-facebook::before {\n  content: \"\\f09a\";\n  margin-left: 6px;\n}\n\n@media (width <=676px) {\n  #footerresponce,\n  #footerresponce1 {\n    display: none;\n  }\n}\n\n@media (width <= 676px) {\n  footer .top-footer .footer-logo {\n    display: block;\n    margin-left: 64px;\n  }\n\n  #our-project {\n    display: none;\n  }\n\n  .bottom-footer {\n    display: none;\n  }\n\n  .Whatsupbuttn {\n    display: none;\n  }\n}\n.custom-link {\n  color: #737373 !important;\n}\n\nfooter .top-footer {\n  padding: 30px 0 0;\n  background-color: #121212;\n  border-top: 1px solid #686060;\n}\n\nfooter .top-footer li a {\n  color: #737373;\n  text-decoration: none;\n}\n\nfooter .bottom-footer .container {\n  border-top: 1px solid #686060;\n}\n\nfooter .top-footer li a:hover {\n  color: #fff;\n  text-decoration: none;\n}\n\n.Whatsupbuttn {\n  position: fixed;\n  left: 30px;\n  bottom: 5px;\n  height: auto;\n  background: #9990;\n  z-index: 1001;\n  display: block; /* Ensure it is displayed by default */\n}\n\n\n/* Hide GIF on small screens (below 676px) */\n@media (max-width: 675px) {\n  .Whatsupbuttn {\n    display: none;\n  }\n}\n\n/* Hide CTA on tablets (768px - 1024px) */\n@media (min-width: 768px) and (max-width: 1024px) {\n  .CTA {\n    display: none !important; /* Forcefully hide CTA */\n  }\n  .Whatsupbuttn {\n    display: block !important; /* Ensure GIF is visible */\n  }\n}\n\n.social-links img {\n  border-radius: 19px;\n  margin-left: 5px;\n  height: 34px;\n  width: 34px;\n}\n\n.social-links {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n@media (max-width: 576px) {\n  .top-footer .col {\n    flex: 0 0 50%; /* 2 columns for small screens */\n    max-width: 50%;\n  }\n}\n\n@media (min-width: 768px) {\n  .top-footer .col {\n    flex: 0 0 33.33%; /* 3 columns for tablets */\n    max-width: 33.33%;\n  }\n}\n\n@media (min-width: 992px) {\n  .top-footer .col {\n    flex: 0 0 25%; /* 4 columns for desktops */\n    max-width: 25%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
